import { apiGet } from "@/lib/api";

export interface ManifestRecord {
  manifest_id: string;
  tenant_id: string | null;
  kind: "binary_attestation" | "deployment_directive";
  signing_key_id: string;
  created_at: string;
  monotonic_counter: number | null;
}

export interface AgentDeployment {
  id: string;
  hostname: string;
  os_type: string;
  agent_version: string;
  fluent_bit_version: string;
  status: string;
  last_heartbeat_at: string;
}

export interface RolloutSummary {
  rollout_id: string;
  status: string;
  strategy: string;
  bucket_pct: number;
  created_at: string;
}

export interface FleetSummary {
  total: number;
  by_version: Record<string, number>;
  stale_count: number;
  unreachable_count: number;
}

export function fetchManifests(): Promise<ManifestRecord[]> {
  return apiGet<{ manifests: ManifestRecord[] }>("/api/v1/admin/manifests").then(
    (data) => data.manifests,
  );
}

export function fetchFleetSummary(): Promise<FleetSummary> {
  return apiGet<FleetSummary>("/api/v1/admin/fleet-summary");
}

export function fetchRollouts(): Promise<RolloutSummary[]> {
  return apiGet<{ rollouts: RolloutSummary[] }>("/api/v1/admin/rollouts").then(
    (data) => data.rollouts,
  );
}
